// ArtifactCopyToasts — глобальный Socket-финал async-копии артефакта (§6.5).
//
// «Независимая копия» bound audio_recap / visual_analysis требует S3-копии →
// durable Inngest workflow `copyArtifactStandalone`. addArtifactCopy сразу
// возвращает mode:'async' (модал закрывается с toast «Копируется…»), а терминал
// приходит Socket'ом:
//   set:artifactCopyReady  → toast «Скопировано» + invalidate кэшей коллекции.
//   set:artifactCopyFailed → toast ошибки (громкая деградация — logging §13a).
//
// Рендерит null; монтируется один раз в layout (под авторизованным shell).

import { useHaptic } from "@studyhub/platform/hooks";
import { toast } from "@studyhub/ui/toast";
import { useTranslation } from "react-i18next";
import { useSocketEvent } from "@/hooks/use-socket-event";
import { IS_MOBILE_PLATFORM } from "@/lib/platform-detect";
import { api } from "@/lib/trpc-client";

export function ArtifactCopyToasts(): null {
	const { t } = useTranslation("library");
	const utils = api.useUtils();
	const haptic = useHaptic();

	useSocketEvent("folders:artifact_copy:ready", ({ setId }) => {
		toast.success(t("addArtifact.copyReady"));
		if (IS_MOBILE_PLATFORM) haptic.notification({ type: "success" });
		// Коллекция получила новый item — перечитать содержимое + список (badge).
		void utils.folders.get.invalidate({ id: setId });
		void utils.library.folders.list.invalidate();
		// Чекбоксы «в коллекции» для скопированного типа могли измениться.
		void utils.folders.listForItem.invalidate();
	});

	useSocketEvent("folders:artifact_copy:failed", () => {
		toast.error(t("addArtifact.copyFailed"));
		if (IS_MOBILE_PLATFORM) haptic.notification({ type: "error" });
	});

	return null;
}
